// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module__button___2Pz15","input":"styles-module__input___24Me1"};